import moment from "moment";
import { FormValidationRule } from "../../forms/types";
import { parseDateFormat } from "../../forms/helper";

const isFutureOrToday: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if ((c.only_date_in_future || c.field_boi_date_in_future) && v) {
        const value = moment(v, "YYYY-MM-DD");
        const today = moment().startOf("day");
        const includeToday =
            c.include_today_in_dates || c.field_boi_date_in_future;
        const dateFormat = c.dateFormat || "dmy";

        if (
            value.isBefore(today) ||
            (!includeToday && value.isSameOrBefore(today))
        ) {
            valid = false;
            message = `Date must be after ${today
                .add(includeToday ? -1 : 0, "days")
                .format(parseDateFormat(dateFormat).toUpperCase())}.`;
        }
    }
    return [valid, message];
};

export default isFutureOrToday;
